import React from 'react';

function Plug(props) {
  return (
    <svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_7841_54068)">
        <path
          d="M12.1096 14.2093C10.9263 13.026 10.2135 11.469 10.1281 9.88093C10.0428 8.29284 10.5917 6.8037 11.6543 5.74112L13.6576 3.7379C13.9232 3.47224 14.2955 3.33501 14.6925 3.35635C15.0896 3.3777 15.4788 3.55587 15.7746 3.85172L22.4672 10.5443C22.7631 10.8402 22.9413 11.2294 22.9626 11.6264C22.9839 12.0235 22.8467 12.3957 22.581 12.6614L20.5778 14.6646C19.5152 15.7272 18.0261 16.2762 16.438 16.1908C14.8499 16.1054 13.2929 15.3927 12.1096 14.2093Z"
          stroke="#292E36"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M10.1973 11.6598L9.11506 12.742C8.81043 13.0466 8.63576 13.4563 8.62952 13.881C8.62329 14.3056 8.786 14.7103 9.08185 15.0061L11.3127 17.237C11.6085 17.5328 12.0133 17.6955 12.4379 17.6893C12.8625 17.683 13.2722 17.5084 13.5768 17.2037L14.659 16.1215"
          stroke="#292E36"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M17.2089 4.64848L20.0771 1.78021"
          stroke="#292E36"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M21.6703 9.11021L24.5386 6.24194"
          stroke="#292E36"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M10.1337 16.1853L8.2215 18.0975C7.61292 18.706 7.26432 19.5247 7.25236 20.3734C7.24041 21.2221 7.56608 22.0313 8.15775 22.623C8.74942 23.2146 9.5586 23.5403 10.4073 23.5283C11.256 23.5164 12.0747 23.1678 12.6832 22.5592C13.2918 21.9506 14.1105 21.602 14.9592 21.5901C15.8079 21.5781 16.6171 21.9038 17.2087 22.4955C17.8004 23.0871 18.1261 23.8963 18.1141 24.745C18.1022 25.5937 17.7536 26.4124 17.145 27.021L13.7031 30.4629"
          stroke="#292E36"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_7841_54068">
          <rect fill="white" height="32" width="32" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Plug;
